import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SecureStorageService } from '../utilities/secure-storage.service'

import { environment } from '../../../../environments/environment';

class URLStoreDO {
  constructor(url, count) {
    this.url = url;
    this.count = count
  }
  url = null
  count = null
}
/**
 * Prefixes all requests with `environment.serverUrl`.
 */
@Injectable()
export class ApiPrefixInterceptor implements HttpInterceptor {

  constructor(private secureStorageService: SecureStorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // request = request.clone({ url: environment.serverHost + request.url });
    this.StoreTheUrlCall(request);
    return next.handle(request);
  }


  private StoreTheUrlCall(request: HttpRequest<any>) {
    let urlSLS = this.secureStorageService.get('URLSLS');
    let parsedURLSLS = JSON.parse(urlSLS);
    if (!urlSLS) {
      let URLDO = {};
      URLDO[request.url] = 1;
      this.secureStorageService.set('URLSLS', JSON.stringify(URLDO));
    }
    else {
      if (parsedURLSLS[request.url]) {
        let count = parsedURLSLS[request.url];
        count = count + 1;
        parsedURLSLS[request.url] = count;
      }
      else {
        parsedURLSLS[request.url] = 1;
      }
    }
    this.secureStorageService.set('URLSLS', JSON.stringify(parsedURLSLS));
    console.log("URL Calls", parsedURLSLS)
  }
}
